import { Routes, Route, HashRouter } from 'react-router-dom';

import ClientData from 'pages/ClientData';
import ClientDataMail from 'pages/ClientDataMail';
import Login from 'pages/Login';
import NotFound from 'pages/NotFound';
import OTP from 'pages/OTP';
import Quote from 'pages/Quote';
import VerifyQuote from 'pages/VerifyQuote';

import RouteGuard from 'auth/RouteGuard/RouteGuard';

const Router = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<RouteGuard />}>
          <Route index element={<Quote />} />
          <Route path="/datos-cliente/telefono" element={<ClientData />} />
          <Route path="/datos-cliente/correo" element={<ClientDataMail />} />
          <Route path="/datos-cliente/otp/:type" element={<OTP />} />
          <Route path="/cotizacion-prestamo" element={<VerifyQuote />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </HashRouter>
  );
};

export default Router;
